<template>
    <v-container fluid>
      <v-flex xs10>        
        <v-card :disabled="!editMode">
          <v-card-text :disabled="!editMode">
                <v-layout :disabled="!editMode">
                  <v-btn v-if="editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top right absolute @click="addCoeficiente()">
                          <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>
                  <v-data-table 
                  :headers="headers"
                  :items="listaCoeficientes"
                  :options.sync ="options"
                  :rows-per-page="options.rowsPerPageItems"
                  v-model="selectedRow"
                  
                  >
                  <template slot="no-data">
                      <v-alert :value="true" color="grey" icon="warning">
                      No hay tasas asociadas.
                      </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                      <tr>
                          <td>
                              <v-edit-dialog
                              :return-value.sync="item.cuotas"
                              :disabled="!editMode"
                              lazy
                              large
                              @save="save"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                              > {{ item.cuotas }}
                              <v-text-field
                                  slot="input"
                                  v-model="item.cuotas"
                                  :rules="[max2chars]"
                                  label="Edit"
                                  single-line
                                  counter
                                  :disabled="!editMode"
                              ></v-text-field>
                              </v-edit-dialog>
                          </td>
                          <td>
                              <v-edit-dialog
                              :return-value.sync="item.coeficiente"
                              lazy
                              large
                              @save="save"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                              :disabled="!editMode"
                              > {{ item.coeficiente }}
                              <v-text-field
                                  slot="input"
                                  v-model="item.coeficiente"
                                  label="Edit"
                                  single-line
                                  counter
                                  :disabled="!editMode"
                              ></v-text-field>
                              </v-edit-dialog>
                          </td>
                          <td>
                              <v-edit-dialog
                              :return-value.sync="item.mostrarAUsuarioComer"
                              lazy
                              large
                              @save="save"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                              :disabled="!editMode"
                              > {{ item.mostrarAUsuarioComer?'Si':'No' }}
                              <v-checkbox
                                  slot="input"
                                  v-model="item.mostrarAUsuarioComer"
                                  :disabled="!editMode"
                              ></v-checkbox>
                              </v-edit-dialog>
                          </td>

                          <td>
                              <v-edit-dialog
                              :return-value.sync="item.mostrarAUsuarioComercio"
                              lazy
                              large
                              @save="save"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                              :disabled="!editMode"
                              > {{ item.mostrarAUsuarioComercio?'Si':'No' }}
                              <v-checkbox
                                  slot="input"
                                  v-model="item.mostrarAUsuarioComercio"
                                  :disabled="!editMode"
                              ></v-checkbox>
                              </v-edit-dialog>
                          </td>
                          <td>
                              <v-edit-dialog
                              :return-value.sync="item.mostrarAUsuarioSucursal"
                              lazy
                              large
                              @save="save"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                              :disabled="!editMode"
                              > {{ item.mostrarAUsuarioSucursal?'Si':'No' }}
                              <v-checkbox
                                  slot="input"
                                  v-model="item.mostrarAUsuarioSucursal"
                                  :disabled="!editMode"
                              ></v-checkbox>
                              </v-edit-dialog>
                          </td>

                          <td class="text-xs-left" >                
                            <v-icon v-if="editMode" small  @click="removeCoeficiente(item)">clear</v-icon>
                          </td>
                      </tr>
                  </template>
                  </v-data-table>
              </v-layout>
            </v-card-text>
        </v-card>
      </v-flex>
    </v-container>
</template>

<script>
import Vue from 'vue'

import {

  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    loading: false,
    max2chars: v => v.length <= 2 || 'Hasta dos caracteres',
    options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 24,
        rowsPerPageItems:[6,12,24]
    },
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
      { text: 'Cuotas', value: 'cuotas',sortable: false },
      { text: 'Tasa', value: 'tasa' ,sortable: false},
      { text: 'Mostrar a Comer', value: 'mostrarAUsuarioComer' ,sortable: false},
      { text: 'Mostrar a Comercio', value: 'mostrarAUsuarioComercio' ,sortable: false},
      { text: 'Mostrar a Sucursal', value: 'mostrarAUsuarioSucursal' ,sortable: false}
    ],        
    listaCoeficientes: [], // registros
    selectedRow: []
  }),
  props: {
    value: {
      type: Array,
      required: true
    },
    propName:{
        type: String,
        required: true,
        default: 'listaCoeficientes'
    },
    label: {
      type: String,
      default: 'Lista Coeficientes'
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  watch:{
    'value': function(item){
        Vue.$log.debug('editMode' + item);          
        this.setLista();
      }
  },
  computed: {  
  },
  created () {
  },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    setLista(){
      Vue.$log.debug(this.propName);       
      Vue.$log.debug(this.value);         
      if(!this.value[this.propName]){
            this.listaCoeficientes = []
            
            this.value[this.propName] = this.listaCoeficientes
        }
        this.listaCoeficientes = this.value;
        Vue.$log.debug(this.listaCoeficientes);       
    },
    addCoeficiente(){
      //si la lista está vacía O si el último item agregado NO está vacio
      if((this.listaCoeficientes && this.listaCoeficientes.length == 0) || !((this.listaCoeficientes[this.listaCoeficientes.length-1].cuotas == 0) || (this.listaCoeficientes[this.listaCoeficientes.length-1].coeficiente == 0))){
        this.listaCoeficientes.push({cuotas:0,coeficiente:0});
      }
    },
    removeCoeficiente(item){
      Vue.$log.debug(item);
      var i = 0;
      for (i = 0; i < this.listaCoeficientes.length; i++) { 
        if(this.listaCoeficientes[i] == item){
            break;
        }
      }
      this.listaCoeficientes.splice(i,1);
    },
    save () {
        Vue.$log.debug('save');
      },
      cancel () {
        Vue.$log.debug('cancel');
      },
      open () {
        Vue.$log.debug('open');
      },
      close () {
        Vue.$log.debug('close');
      }
  },
  
}

</script>